"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var PhoneMobileSmart = function PhoneMobileSmart(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "Glyphs/Devices/*Phone_Mobile_Smart",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-phone-mobile-smart" + unique,
    xlinkHref: "#path-1-phone-mobile-smart" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-phone-mobile-smart" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7,1 L17,1 C17.5522847,1 18,1.44771525 18,2 L18,22 C18,22.5522847 17.5522847,23 17,23 L7,23 C6.44771525,23 6,22.5522847 6,22 L6,2 C6,1.44771525 6.44771525,1 7,1 Z M7,2 L7,20 L17,20 L17,2 L7,2 Z M11.5,22 L12.5,22 C12.7761424,22 13,21.7761424 13,21.5 C13,21.2238576 12.7761424,21 12.5,21 L11.5,21 C11.2238576,21 11,21.2238576 11,21.5 C11,21.7761424 11.2238576,22 11.5,22 Z",
    fill: "inherit",
    id: "path-1-phone-mobile-smart" + unique
  }))));
};

PhoneMobileSmart.propTypes = propTypes;
var _default = PhoneMobileSmart;
exports["default"] = _default;